<template>
  <v-container grid-list-xl>
    <v-card>
      <v-toolbar flat color="orange lighten-5">
        <v-icon left color="orange darken-3">report_problem</v-icon>
        <v-toolbar-title class="font-weight-bold orange--text text--darken-3">Kayıp Siparişler</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip color="orange darken-3" text-color="white" small label>Toplam {{ lostOrders.length }} kayıt</v-chip>
      </v-toolbar>

      <v-layout wrap align-center class="px-3 pt-3">
        <v-flex xs12 sm3 class="px-2">
          <v-menu v-model="menu1" :close-on-content-click="false" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="startDate" label="Başlangıç Tarihi" prepend-icon="event" readonly v-on="on" hide-details></v-text-field>
            </template>
            <v-date-picker v-model="startDate" locale="tr-TR" @input="menu1 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm3 class="px-2">
          <v-menu v-model="menu2" :close-on-content-click="false" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="endDate" label="Bitiş Tarihi" prepend-icon="event" readonly v-on="on" hide-details></v-text-field>
            </template>
            <v-date-picker v-model="endDate" locale="tr-TR" @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm3 class="px-2">
          <v-text-field v-model="search" label="Ara (sipariş no / müşteri)" prepend-icon="search" clearable hide-details></v-text-field>
        </v-flex>
        <v-flex xs12 sm3 class="px-2">
          <v-btn color="orange darken-3" dark :loading="loading" @click="load">
            <v-icon left>filter_list</v-icon>Listele
          </v-btn>
        </v-flex>
      </v-layout>

      <v-data-table :headers="headers" :items="filteredOrders" :loading="loading" :rows-per-page-items="[25, 50, 100, { text: 'Tümü', value: -1 }]" class="elevation-0 mt-2">
        <template v-slot:items="props">
          <td class="px-2">{{ formatDate(props.item.orderDate) }}</td>
          <td class="px-2">{{ firstOrderNumber(props.item) }}</td>
          <td class="px-2">{{ props.item.recipientName }}</td>
          <td class="px-2">{{ props.item.shippingCity }}</td>
          <td class="px-2">{{ productSummary(props.item) }}</td>
          <td class="px-2 text-xs-center">{{ props.item.quantity }}</td>
          <td class="px-2 text-xs-right">{{ formatMoney(props.item.totalAmount) }} ₺</td>
          <td class="px-2">
            <v-chip small color="blue-grey darken-1" text-color="white">{{ props.item.mpName }}</v-chip>
          </td>
          <td class="px-2">
            <v-chip small :color="props.item.lostSource === 'YK Kargo' ? 'deep-orange darken-1' : 'orange darken-2'" text-color="white">{{ props.item.lostSource }}</v-chip>
          </td>
          <td class="px-2">{{ formatDate(props.item.lostDate) }}</td>
        </template>
        <template v-slot:no-data>
          <div class="pa-4 text-xs-center grey--text">{{ loading ? 'Yükleniyor...' : 'Seçili aralıkta kayıp sipariş yok.' }}</div>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { authenticationService } from "@/_services";

export default {
  data() {
    return {
      loading: false,
      menu1: false,
      menu2: false,
      startDate: null,
      endDate: null,
      search: '',
      tenantId: null,
      mpId: null,
      lostOrders: [],
    };
  },
  computed: {
    headers() {
      return [
        { text: 'Tarih', value: 'orderDate', sortable: true },
        { text: 'Sipariş No', value: 'orderNumber', sortable: false },
        { text: 'Müşteri', value: 'recipientName', sortable: false },
        { text: 'Şehir', value: 'shippingCity', sortable: false },
        { text: 'Ürün', value: 'productName', sortable: false },
        { text: 'Adet', value: 'quantity', sortable: false, align: 'center' },
        { text: 'Tutar', value: 'totalAmount', sortable: false, align: 'right' },
        { text: 'Marketplace', value: 'mpName', sortable: false },
        { text: 'Kaynak', value: 'lostSource', sortable: false },
        { text: 'Kayıp Tarihi', value: 'lostDate', sortable: true },
      ];
    },
    filteredOrders() {
      const q = (this.search || '').trim().toLocaleLowerCase('tr');
      if (!q) return this.lostOrders;
      return this.lostOrders.filter((o) => {
        const inItems = (o.items || []).some((i) =>
          (i.orderNumber || '').toLocaleLowerCase('tr').includes(q));
        return inItems
          || (o.packageNumber || '').toLocaleLowerCase('tr').includes(q)
          || (o.recipientName || '').toLocaleLowerCase('tr').includes(q);
      });
    },
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.lostOrders = (await this.$store.dispatch('orders/getLostOrders', {
          startDate: this.startDate,
          endDate: this.endDate,
        })) || [];
      } catch (e) {
        this.lostOrders = [];
      } finally {
        this.loading = false;
      }
    },
    firstOrderNumber(order) {
      const items = order.items || [];
      if (items.length === 0) return order.packageNumber || '-';
      return items[0].orderNumber || order.packageNumber || '-';
    },
    productSummary(order) {
      const items = order.items || [];
      if (items.length === 0) return '-';
      const first = items[0].productName || '-';
      return items.length > 1 ? `${first} (+${items.length - 1})` : first;
    },
    formatDate(value) {
      if (!value) return '';
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      return d.toLocaleDateString('tr-TR');
    },
    formatMoney(value) {
      return (Number(value) || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
  async mounted() {
    const selectedTenant = localStorage.getItem('selectedTenantId');
    const selectedMp = localStorage.getItem('selectedMpId');
    const currentUser = authenticationService.currentUserValue;
    this.tenantId = selectedTenant || (currentUser && currentUser.tenantId) || localStorage.getItem('tenantId');
    this.mpId = selectedMp || (currentUser && currentUser.mpId);

    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - 30);
    this.startDate = past.toISOString().substr(0, 10);
    this.endDate = today.toISOString().substr(0, 10);

    await this.load();
  },
};
</script>
